import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-deleted',
  templateUrl: './user-deleted.component.html',
  styleUrls: ['./user-deleted.component.scss']
})
export class UserDeletedComponent implements OnInit {
  currentUser;
  constructor(
    private userService: UserService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.userService.user.subscribe((u) => {
      if (u && u.uid) {
        this.currentUser = u;
        if (!this.currentUser.banned) {
          this.router.navigateByUrl('/');
        }
      }
    })
  }

  logout() {
    this.userService.logout();
  }

}
